import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pasttransaction',
  templateUrl: './pasttransaction.component.html',
  styleUrls: ['./pasttransaction.component.scss']
})
export class PasttransactionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
